export const usePermission = () => {
  const storedUserInfo = sessionStorage.getItem("adminInfo");
  const userInfo = storedUserInfo ? JSON.parse(storedUserInfo) : null;

  const pagePermissions = userInfo?.pagepermission || [];

  const hasPageAccess = (pageName) => {
    if (!pagePermissions.length) return true;
    return pagePermissions.some((p) => p.page_name === pageName);
  };

  const hasSessionAccess = (pageName, sessionName) => {
    if (!pagePermissions.length) return true;
    const page = pagePermissions.find((p) => p.page_name === pageName);
    if (!page) return false;
    return page.sessions.some((s) => s.session_name === sessionName);
  };


  const hasSessionAccessByName = (pageName, sessionLabel) => {
    if (!pagePermissions || pagePermissions.length === 0) return true;
    const page = pagePermissions.find((p) => p.page_name === pageName);
    if (!page) return false;
    return page.sessions.some((s) => s.session_label === sessionLabel);
  };

  return {
    hasPageAccess,
    hasSessionAccess,
    hasSessionAccessByName,
  };
};
